// removed by extract-text-webpack-plugin
module.exports = {"Pepper":"#938D88","greyedOut":"G4ce000","overlayTransition":"Gaa5d5a G19f850 G3b7ead G1a0d7b","modal":"Gc9c3ea","willFade":"Gdc2185","fadeOut":"Gfb5700 Gdc2185"};